import React from 'react';
import './OrderFlowMultiLevelReferralTable.css'; 

const MultiLevelReferralTable = () => {
    return (
        <div className='bg-blue-800 mb-4'>
            <table>
                <thead className='text-black'>
                    <tr>
                        <th>Level</th>
                        <th>Customers</th>
                        <th>Rate</th>
                        <th>Price</th>
                        <th>Commission / Sale (₹)</th>
                        <th>Total Commission (₹)</th>
                    </tr>
                </thead>
                <tbody className='text-black'>
                    <tr className='text-black'>
                        <td>1</td>
                        <td>5</td>
                        <td>20.00%</td>
                        <td>599.00</td>
                        <td>119.80</td>
                        <td>599.00</td>
                    </tr>
                    <tr>
                        <td>2</td>
                        <td>5<sup>2</sup></td>
                        <td>4.00%</td>
                        <td>599.00</td>
                        <td>23.96</td>
                        <td>599.00</td>
                    </tr>
                    <tr>
                        <td>3</td>
                        <td>5<sup>3</sup></td>
                        <td>1.00%</td>
                        <td>599.00</td>
                        <td>5.99</td>
                        <td>748.75</td>
                    </tr>
                    <tr>
                        <td>4</td>
                        <td>5<sup>4</sup></td>
                        <td>1.00%</td>
                        <td>599.00</td>
                        <td>5.99</td>
                        <td>3,743.75</td>
                    </tr>
                    <tr>
                        <td>5</td>
                        <td>5<sup>5</sup></td>
                        <td>1.00%</td>
                        <td>599.00</td>
                        <td>5.99</td>
                        <td>18,718.75</td>
                    </tr>
                    <tr>
                        <td>6</td>
                        <td>5<sup>6</sup></td>
                        <td>1.00%</td>
                        <td>599.00</td>
                        <td>5.99</td>
                        <td>93,593.75</td>
                    </tr>
                    <tr>
                        <td>7</td>
                        <td>5<sup>7</sup></td>
                        <td>1.00%</td>
                        <td>599.00</td>
                        <td>5.99</td>
                        <td>467,968.75</td>
                    </tr>
                    <tr>
                        <td>8</td>
                        <td>5<sup>8</sup></td>
                        <td>1.00%</td>
                        <td>599.00</td>
                        <td>5.99</td>
                        <td>2,339,843.75</td>
                    </tr>
                </tbody>
            </table>
            <p className="mb-4 text-white">
                N.B. -
                <ol>
                    <li>Get your product FREE - You refer (sale) to 5</li>
                    <li>Earn PASSIVE INCOME - Up to level 8 / estimated 15 lakh Rs. or more lifetime</li>
                    <li>Earn Super Ambassador BONUS - For 5 lakh units sales (down the line)</li>
                    <li>NEW digital products will be added regularly</li>
                    <li>Estimated in ₹</li>
                    <li>Referral sales Overseas may yield more income</li>
                    <li>Price INCLUSIVE 18% GST</li>
                </ol>
            </p>
        </div>
    );
};

export default MultiLevelReferralTable;
